// @ts-nocheck
/* eslint-disable spire/export-styles */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { SafeDictionary } from "@insite/client-framework/Common/Types";

import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { getUnitNetPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { canAddToCart, hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import translate from "@insite/client-framework/Translate";
// import { CartLineModel, ProductSubscriptionDto } from "@insite/client-framework/Types/ApiModels"; Starter Custom Code
import ProductAddedToCartMessage from "@insite/content-library/Components/ProductAddedToCartMessage";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import React, { useContext, useState } from "react";
// import { connect, ResolveThunks } from "react-redux"; // Starter Custom Code

// Store Custom Code
import StoreVariantsButton from "@store/Library/Components/Foundation/StoreVariantsButton";

// Starter Custom Code - >
import {
    HasProductContext,
    ProductContext,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, ProductInventoryDto, ProductSubscriptionDto } from "@insite/client-framework/Types/ApiModels";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { useAllowBackOrder } from "@store/Framework/Store/Bunzl/Components/ProductAddToCartButton/ProductAddToCartButtonHooks";
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import { useAnalytics } from "@store/Framework/Store/Context/ContextHooks";
import useCanAddToCart from "@store/Framework/Store/Data/Products/ProductsHooks/useCanAddToCart";
import SignInToSeePriceButton from "@store/Library/Components/Foundation/SignInToSeePriceButton";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import {
    useCanAddToCart as toolKitUseCanAddToCart,
    useHasEnoughInventory,
} from "@toolkit/Framework/Store/Data/Products/ProductsHooks";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";

export interface ProductAddToCartButtonProps extends Omit<OwnProps, keyof ButtonPresentationProps> {}
// <-- Starter Custom Code

export interface OwnProps /* Starter Custom Code */ {
    labelOverride?: string;
    extendedStyles?: ProductAddToCartButtonStyles; // Starter Custom Code
    notes?: string;
    configurationSelection?: SafeDictionary<string>;
    configurationCompleted?: boolean;
    variantSelectionCompleted?: boolean;
    subscription?: ProductSubscriptionDto;
    onAddToCartClick?: () => void;
    // Starter Custom Code
    overridedStyles?: ProductAddToCartButtonStyles;
    isLink?: boolean;
    variantButtonExtendedStyles?: ButtonPresentationProps; // Store Custom Code
}

export const useShowProductAddToCartButton = (
    configurationCompleted: boolean | undefined,
    variantSelectionCompleted: boolean | undefined,
) => {
    const productContext = useContext(ProductContext);
    const { product, productInfo } = productContext;
    const hasEnoughInventory = useHasEnoughInventory(productContext);
    const canAddToCart = toolKitUseCanAddToCart(
        product,
        productInfo,
        configurationCompleted,
        variantSelectionCompleted,
    );

    return !((!hasEnoughInventory && !productInfo.failedToLoadInventory) || !canAddToCart);
};
// Starter Custom Code - >
export interface CustomProductInventoryDto extends ProductInventoryDto {
    preventAddToCart: boolean;
}
// <-- Starter Custom Code

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext;

const mapStateToProps = (state: ApplicationState, props: OwnProps & HasProductContext) => {
    const {
        productSettings, // Starter Custom Code
        cartSettings: { addToCartPopupTimeout },
    } = getSettingsCollection(state);
    return {
        canAddToCart: canAddToCart(
            state,
            props.productContext.product,
            props.productContext.productInfo,
            props.configurationCompleted,
            props.variantSelectionCompleted,
        ),
        hasEnoughInventory: hasEnoughInventory(state, props.productContext),
        isUpdatingCart: state.context.isUpdatingCart,
        showAddToCartConfirmationDialog: productSettings.showAddToCartConfirmationDialog, // Starter Custom Code
        addToCartPopupTimeout,
        // Starter Custom Code
        productSettings,
        currentCurency: state.context.session.currency?.currencyCode,
    };
};

const mapDispatchToProps = {
    addToCart: makeHandlerChainAwaitable<Parameters<typeof addToCart>[0], CartLineModel>(addToCart),
};

/* Starter Custom Code - Start */
export interface ProductAddToCartButtonStyles extends ButtonPresentationProps {
    button?: ButtonPresentationProps;
    link?: LinkPresentationProps;
}

export const productAddToCartButtonStyles: ProductAddToCartButtonStyles = {
    button: {
        variant: "primary",
        css: css`
            ${x => x.theme.button.primary.css}
        `,
    },
    link: linkGetActionLinkProps(PlusCircleFill),
};
/* Starter Custom Code - End */

const ProductAddToCartButton = ({
    productContext: {
        product, // Starter Custom Code
        productInfo, // Starter Custom Code
    },
    onAddToCartClick,
    hasEnoughInventory,
    isUpdatingCart,
    showAddToCartConfirmationDialog,
    addToCartPopupTimeout,
    addToCart,
    // canAddToCart, // Starter Custom Code
    labelOverride,
    extendedStyles,
    overridedStyles,
    notes,
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    subscription,
    // Starter Custom Code - >
    productContext,
    currentCurency,
    productSettings,
    // <--- Starter Custom Code
    variantButtonExtendedStyles, // Store Custom Code
    ...otherProps
}: Props) => {
    const toasterContext = useContext(ToasterContext);
    const trackAddToCart = ga.use.trackAddToCart(); // Starter Custom Code
    const styles = useExpandProps(productAddToCartButtonStyles, extendedStyles, overridedStyles); // Starter Custom Code
    const [isLoading, setIsLoading] = useState(false); // Starter Custom Code

    // Starter Custom Code - >
    const preventAddToCart = (productInfo?.inventory as CustomProductInventoryDto)?.preventAddToCart ?? false;
    const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();
    const allowBackOrder = useAllowBackOrder();
    const productCanAddToCart = useCanAddToCart(
        product,
        productSettings,
        productInfo,
        hasEnoughInventory,
        configurationCompleted,
        variantSelectionCompleted,
        allowBackOrder,
    );

    const canAddToCart = !preventAddToCart && productCanAddToCart;

    if (!isSignedInAndhasToBeSignedIn) {
        return <SignInToSeePriceButton {...styles} />;
    }

    if (product.isVariantParent) {
        // Store Custom Code
        return (
            <StoreVariantsButton extendedStyles={variantButtonExtendedStyles} path={productInfo.productDetailPath} />
        );
    }
    // <-- Starter Custom Code
    const addToCartClickHandler = async () => {
        onAddToCartClick?.();
        if (!canAddToCart /* Starter Custom Code */) {
            toasterContext.addToast({ body: siteMessage("Cart_InvalidPrice"), messageType: "danger" });
            return;
        }

        setIsLoading(true); // Starter Custom Code

        const sectionOptions =
            configurationSelection && Object.values(configurationSelection).length > 0
                ? Object.values(configurationSelection)
                      .filter(sectionOptionId => !!sectionOptionId)
                      .map(sectionOptionId => ({ sectionOptionId }))
                : undefined;
        const cartline = (await addToCart({
            // Starter Custom Code
            productId: product.id,
            qtyOrdered: productInfo.qtyOrdered,
            unitOfMeasure: productInfo.unitOfMeasure,
            // Starter Custom Code
            notes,
            sectionOptions,
            subscription,
        })) as CartLineModel;

        setIsLoading(false); // Starter Custom Code
        trackAddToCart(); // Starter Custom Code

        if (showAddToCartConfirmationDialog) {
            toasterContext.addToast({
                body: <ProductAddedToCartMessage isQtyAdjusted={cartline.isQtyAdjusted} multipleProducts={false} />,
                messageType: "success",
                timeoutLength: cartline.isQtyAdjusted ? 1000 * 60 * 60 * 24 * 365 : addToCartPopupTimeout,
            });
        }
    };

    return (
        <Button
            {...styles}
            onClick={addToCartClickHandler}
            disabled={productInfo.qtyOrdered <= 0 || isUpdatingCart || !canAddToCart /* Starter Custom Code */}
            {...otherProps}
        >
            {labelOverride ?? translate("Add to Cart")}
        </Button>
    );
};
export default withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductAddToCartButton));
